// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7e1b8a11","239":"5ce19594","455":"ae9ab87d"}[chunkId] + ".chunk.js";
};